import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import Logo from '../components/Logo';
import ThemeToggle from '../components/ThemeToggle';

export default function ForgotPassword() {
	const [email, setEmail] = useState('');
	const [sent, setSent] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError(null);
		try {
			await api.post('/auth/forgot-password', { email });
			setSent(true);
		} catch (err) {
			setError(err.response?.data?.detail ?? err.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='min-h-screen bg-brand-light-bg dark:bg-brand-dark-bg flex flex-col'>
			<nav className='flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-white/10'>
				<Logo className='h-12' />
				<ThemeToggle />
			</nav>
			<div className='flex-1 flex items-center justify-center px-4'>
				<div className='bg-white dark:bg-brand-dark-surface rounded-2xl border border-gray-100 dark:border-white/10 p-8 w-full max-w-sm'>
					<Logo className='h-12 mb-6' />
					{sent ? (
						<div className='text-center'>
							<div className='w-12 h-12 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center mx-auto mb-4'>
								<svg
									className='w-6 h-6 text-green-600'
									fill='none'
									viewBox='0 0 24 24'
									stroke='currentColor'
									strokeWidth={2}
								>
									<path
										strokeLinecap='round'
										strokeLinejoin='round'
										d='M5 13l4 4L19 7'
									/>
								</svg>
							</div>
							<h1 className='text-xl font-bold text-gray-900 dark:text-white mb-2'>
								Check your inbox
							</h1>
							<p className='text-gray-400 text-sm mb-6'>
								If <strong>{email}</strong> has an account, we've sent a reset
								link. Check your spam folder too.
							</p>
							<Link
								to='/login'
								className='text-brand-violet dark:text-brand-violet-on-dark text-sm hover:underline'
							>
								Back to sign in
							</Link>
						</div>
					) : (
						<>
							<h1 className='text-2xl font-bold text-gray-900 dark:text-white mb-1'>
								Forgot password?
							</h1>
							<p className='text-gray-400 text-sm mb-6'>
								Enter your email and we'll send you a reset link.
							</p>
							{error && <p className='text-red-500 text-sm mb-4'>{error}</p>}
							<form
								onSubmit={handleSubmit}
								className='flex flex-col gap-4'
							>
								<input
									type='email'
									required
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder='your@email.com'
									className='border border-gray-200 dark:border-white/10 bg-white dark:bg-brand-dark-bg rounded-lg px-4 py-2.5 text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-violet dark:focus:ring-brand-violet-on-dark'
								/>
								<button
									type='submit'
									disabled={loading}
									className='bg-brand-violet text-white py-2.5 rounded-lg font-medium hover:opacity-90 disabled:opacity-50 transition'
								>
									{loading ? 'Sending...' : 'Send reset link'}
								</button>
							</form>
							<p className='text-center text-sm text-gray-400 mt-6'>
								<Link
									to='/login'
									className='text-brand-violet dark:text-brand-violet-on-dark hover:underline'
								>
									Back to sign in
								</Link>
							</p>
						</>
					)}
				</div>
			</div>
		</div>
	);
}
